import ajax from '../utils/request'
const avCommentApi = {
  // 获取AV解说列表
  getAvCommentList(params) {
    return ajax({
      url: '/avcomment/list',
      type: 'post',
      params: params
    })
  },
  // 添加
  addAvComment(params) {
    return ajax({
      url: '/avcomment/add',
      type: 'post',
      params: params
    })
  },
  // 编辑
  editAvComment(params) {
    return ajax({
      url: '/avcomment/edit',
      type: 'post',
      params: params
    })
  },
}
export default avCommentApi
